/* Interfaces common to multiple apis */

export interface ICurrency {
  id: number;
  name: string;
  code: string;
  symbol: string
  unitsPerSymbol: number;
}

// Duplicated from PHP constants.
export enum SpecialTransactionIds {
  CREDIT = 'CREDIT',
  FREE = 'FREE',
  INVOICE = 'INVOICE',
  VOID = 'VOID',
  ZERO = 'ZERO',
  UNCOLLECTIBLE = 'UNCOLLECTIBLE',
  AGENCY_INVOICED = "AGENCY INVOICED",
  INEXPLICABLY_PAID = "INEXPLICABLY PAID",
  COVERED = 'COVERED',
  ERROR = 'ERROR',
}
